import moment from "moment-timezone/moment-timezone.js";
import _timezones from "./data.json";

moment.tz.load(_timezones);

export default moment;

export const timezones = {
    default: {
        tz: ["EST", "EDT"],
        lang: "en-US",
        city: "America/New_York"
    },
    fr: {
        tz: ["CEST"],
        lang: "fr-FR",
        city: "Europe/Paris"
    },
    de: {
        tz: ["CEST"],
        lang: "de-DE",
        city: "Europe/Berlin"
    },
    nl: {
        tz: ["CEST"],
        lang: "nl-NL",
        city: "Europe/Amsterdam"
    },
    es: {
        tz: ["CEST"],
        lang: "es-ES",
        city: "Europe/Madrid"
    },
    uk: {
        tz: ["GMT"],
        lang: "en-GB",
        city: "Europe/London"
    },
    au: {
        tz: ["AEST", "AEDT"],
        lang: "en-AU",
        city: "Australia/Melbourne" // "Australia/Sydney"
    },
    cn: {
        tz: ["CST"],
        lang: "zh-CH",
        city: "Asia/Shanghai"
    },
    hk: {
        tz: ["HKT"],
        lang: "zh-HK",
        city: "Asia/Hong_Kong"
    },
    id: {
        tz: ["WIB"],
        lang: "id-ID",
        city: "Asia/Jakarta"
    },
    jp: {
        tz: ["JST"],
        lang: "ja-JP",
        city: "Asia/Tokyo"
    },
    kr: {
        tz: ["KST"],
        lang: "kr-KR",
        city: "Asia/Seoul"
    },
    sg: {
        tz: ["SGT"],
        lang: "en-SG",
        city: "Asia/Singapore"
    },
    tw: {
        tz: ["CST"],
        lang: "zh-TW",
        city: "Asia/Taipei"
    },
    in: {
        tz: ["IST"],
        lang: "en-IN",
        city: "Asia/Kolkata"
    }
};

// export const reg = /^(\d{4}-\d{2}-\d{2}T\d{2}:\d{2}:\d{2}[\+\-]\d{4})\s(\w+(?:[+-]\d+)?)\s(\w+(?:\/\w+)?)$/i;
export const reg = /^([^\s]+)\s([^\s]+)\s([^\s]+)$/i;
export function parseISOTZ(datetimeString) {
    // const [, stISO8601, stTimeZone, stLocale] =
    return ((!!datetimeString && reg.test(datetimeString)) ? datetimeString.match(reg) : undefined) ?? undefined;
}